<template>
	<div>
		<div class="subpageTop">
			<el-image class="st_background" :src="image" :fit="'cover'"></el-image>
		</div>
		
		<div class="subpageTop_list" v-if="tabShow">
			<div class="st_li_div wow fadeInLeft" data-wow-duration="0.5s" data-wow-delay="0.5s" data-wow-offset="0" v-for="(item,index) in tabList" :key="index" @click="anchorPoint(index)">
				<div class="st_li_mask"></div>
				<div class="st_li_name">{{item.name}}</div>
			</div>
		</div>	
	</div>
</template>

<script>
	import WOW from "wowjs";
	export default{
		data(){
			return{
				
			}
		},
		mounted() {
			let wow = new WOW.WOW({ boxClass: 'wow', animateClass: 'animated', offset:0, mobile: true, live: true }); wow.init();
		},
		
		props: {
			image:{
				type:String,
				default:"",
			},
			tabShow:{
				type:Boolean,
				default:false
			},
			tabList:{
				type:Array,
				default:()=>[]
			}
		},
		methods: {
			//-------------------锚点跳转-------------------
			anchorPoint(index){
				this.$emit('anchorPoint',index)
			}
		}
	}
</script>

<style lang="less">
	@media only screen and (min-width:800px) {
		.subpageTop{
			position: relative;
			height: 30vw;
			min-height: 200px;
			overflow: hidden;
			width: 100%;
			background: red;
			margin-top: 50px;
		}
		.st_background{
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
		}
		
		//tabs列表
		.subpageTop_list{
			border-bottom: 1px solid #ddd;
			display: flex;
			justify-content: center;
			// overflow: hidden;
			position: relative;
		}
		
		.st_li_div{
			padding: 20px 40px;
			overflow: hidden;
			position: relative;
			cursor: pointer;
		}
		
		.st_li_mask{
			z-index: 4;
			background: linear-gradient(to right, rgba(98, 30, 210), rgba(48, 102, 245));
			width: 100%;
			height: 100%;
			bottom: 0;
			left: -100%;
			transition: all 0.5s;
			position: absolute;
		}
		
		.st_li_div:hover .st_li_mask {
			left: 0;
		}
		
		.st_li_name{
			position: relative;
			z-index: 99;
			color: #000;
			font-size: 18px;
			font-weight: bold;
			transition: all 0.5s;
		}
		
		.st_li_div:hover .st_li_name {
			color: #fff;
		}
	}
	@media only screen and (max-width:799.9px) {
		.subpageTop{
			position: relative;
			height: 30vw;
			min-height: 200px;
			overflow: hidden;
			width: 100%;
			background: red;
			margin-top: 50px;
		}
		.st_background{
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
		}
		
		//tabs列表
		.subpageTop_list{
			border-bottom: 1px solid #ddd;
			display: flex;
			justify-content: center;
			// overflow: hidden;
			position: relative;
		}
		
		.st_li_div{
			padding: calc(0.8rem * var(--scale)) calc(1.3rem * var(--scale));
			overflow: hidden;
			position: relative;
			cursor: pointer;
		}
		
		.st_li_mask{
			z-index: 4;
			background: linear-gradient(to right, rgba(98, 30, 210), rgba(48, 102, 245));
			width: 100%;
			height: 100%;
			bottom: 0;
			left: -100%;
			transition: all 0.5s;
			position: absolute;
		}
		
		.st_li_div:hover .st_li_mask {
			left: 0;
		}
		
		.st_li_name{
			position: relative;
			z-index: 99;
			font-size: calc(0.9rem * var(--scale));
			color: #aaa;
			transition: all 0.5s;
		}
		
		.st_li_div:hover .st_li_name {
			color: #fff;
		}
	}
	
</style>